import { memoize } from "lodash"

export var groupBy = function(xs, key) {
    if (typeof xs !== "object") return {}
    if (typeof xs.reduce !== "function") return {}
    return xs.reduce(function(rv, x) {
        ;(rv[x[key]] = rv[x[key]] || []).push(x)
        return rv
    }, {})
}
// => {3: ["one", "two"], 5: ["three"]}

export var unique = function(a) {
    return a.sort().filter(function(item, pos, ary) {
        return !pos || item !== ary[pos - 1]
    })
}

const map = new WeakMap()
export const memoizeTwoArgs = fn =>
    memoize(fn, (a, b) => {
        if (typeof a === "undefined" || typeof b === "undefined") {
            return Math.random() + 1
        }
        if (!map.has(a)) map.set(a, Math.random())
        if (!map.has(b)) map.set(b, Math.random())

        return map.get(a) + "_" + map.get(b)
    })



// WEBPACK FOOTER //
// ./src/utils/utils.js